<template>
  <el-table-column :label="label" :prop="prop" class-name="email" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'メールアドレス'
    },
    prop: {
      type: String,
      default: 'email'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.email {
      width: 25em;
    }
  }
}
</style>
